export const chatKeys = {
  all: ['chat'] as const,
  conversations: () => [...chatKeys.all, 'conversations'] as const,
  messages: (chatUlid: string) =>
    [...chatKeys.all, 'messages', chatUlid] as const,
  groupMembers: (chatUlid: string) =>
    [...chatKeys.all, 'groupMembers', chatUlid] as const,
  contacts: (params: Record<string, unknown>) =>
    [...chatKeys.all, 'contacts', params] as const,
}
